import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Breadcrumb, Menu, Layout, Button, Avatar, Dropdown, Space } from 'antd';
import { UserOutlined, SettingOutlined, LogoutOutlined, MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
const { Header } = Layout;
export const BreadcrumbNav = ({ items, onItemClick }) => {
    const breadcrumbItems = items.map((item, index) => ({
        key: index,
        title: (_jsxs("span", { children: [item.icon && _jsx("span", { style: { marginRight: 8 }, children: item.icon }), item.path && onItemClick ? (_jsx("a", { onClick: () => onItemClick(item.path), children: item.title })) : (item.title)] }))
    }));
    return (_jsx(Breadcrumb, { style: { margin: '16px 0' }, items: breadcrumbItems }));
};
export const SidebarMenu = ({ items, selectedKeys, onSelect, collapsed = false }) => {
    const handleMenuClick = ({ key }) => {
        onSelect(key);
    };
    return (_jsx(Menu, { mode: "inline", selectedKeys: selectedKeys, onClick: handleMenuClick, inlineCollapsed: collapsed, style: { height: '100%', borderRight: 0 }, 
        // Map to AntD ItemType to satisfy types in strict mode
        items: items.map((it) => it.children && it.children.length
            ? {
                key: it.key,
                icon: it.icon,
                label: it.label,
                children: it.children.map((ch) => ({ key: ch.key, icon: ch.icon, label: ch.label }))
            }
            : { key: it.key, icon: it.icon, label: it.label }) }));
};
export const TopNav = ({ title, logo, user, onLogout, onMenuToggle, collapsed = false, actions }) => {
    const userMenuItems = [
        {
            key: 'profile',
            label: 'Profile',
            icon: _jsx(UserOutlined, {}),
        },
        {
            key: 'settings',
            label: 'Settings',
            icon: _jsx(SettingOutlined, {}),
        },
        {
            type: 'divider',
        },
        {
            key: 'logout',
            label: 'Logout',
            icon: _jsx(LogoutOutlined, {}),
            onClick: onLogout,
        },
    ];
    return (_jsxs(Header, { style: {
            padding: '0 24px',
            background: '#fff',
            borderBottom: '1px solid #f0f0f0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }, children: [_jsxs("div", { style: { display: 'flex', alignItems: 'center' }, children: [onMenuToggle && (_jsx(Button, { type: "text", icon: collapsed ? _jsx(MenuUnfoldOutlined, {}) : _jsx(MenuFoldOutlined, {}), onClick: onMenuToggle, style: { marginRight: 16 } })), logo && (_jsx("div", { style: { marginRight: 16 }, children: logo })), _jsx("h1", { style: { margin: 0, fontSize: 18, fontWeight: 600 }, children: title })] }), _jsxs("div", { style: { display: 'flex', alignItems: 'center' }, children: [actions && (_jsx(Space, { style: { marginRight: 16 }, children: actions })), user && (_jsx(Dropdown, { menu: { items: userMenuItems }, placement: "bottomRight", arrow: true, children: _jsxs("div", { style: {
                                display: 'flex',
                                alignItems: 'center',
                                cursor: 'pointer',
                                padding: '8px 12px',
                                borderRadius: 6,
                                transition: 'background-color 0.2s'
                            }, onMouseEnter: (e) => {
                                e.currentTarget.style.backgroundColor = '#f5f5f5';
                            }, onMouseLeave: (e) => {
                                e.currentTarget.style.backgroundColor = 'transparent';
                            }, children: [_jsx(Avatar, { src: user.avatar, icon: _jsx(UserOutlined, {}), style: { marginRight: 8 } }), _jsxs("div", { children: [_jsx("div", { style: { fontWeight: 500, fontSize: 14 }, children: user.name }), user.email && (_jsx("div", { style: { fontSize: 12, color: '#666' }, children: user.email }))] })] }) }))] })] }));
};
//# sourceMappingURL=index.js.map